import { AnyAction } from '@reduxjs/toolkit'
import { Epic } from 'redux-observable'
import { of, from } from 'rxjs'
import { switchMap, map, catchError, withLatestFrom, filter } from 'rxjs/operators'

import {
  fetchNewNumberData,
  fetchNewNumberDataSuccess,
  fetchNewNumberDataError,
  fetchOperatorData,
  fetchOperatorError,
  fetchOperatorSuccess,
} from './line.reducer'

import LineService from '../services/line.service'

import { RootState } from '~/core/store/root.reducer'
import CustomerService from '~/customer/services/customer.service'

const fetchNewNumberEpic: Epic<AnyAction, AnyAction, RootState, { lineService: LineService }> = (
  action$,
  state$,
  { lineService },
) =>
  action$.pipe(
    filter(fetchNewNumberData.match),
    withLatestFrom(state$),
    switchMap(([action]) =>
      from(lineService.fetchNewNumber()).pipe(
        map((result) => fetchNewNumberDataSuccess({ ...result, lineId: action.payload })),
        catchError((error: Error) =>
          of(
            fetchNewNumberDataError({
              errorMessage: error.message,
              errorCode: '500',
              lineId: action.payload,
            }),
          ),
        ),
      ),
    ),
  )

const fetchOperatorEpic: Epic<
  AnyAction,
  AnyAction,
  RootState,
  { lineService: LineService; customerService: CustomerService }
> = (action$, state$, { lineService, customerService }) =>
  action$.pipe(
    filter(fetchOperatorData.match),
    withLatestFrom(state$),
    switchMap(([action, state]) =>
      from(
        customerService.fetchClientExists({
          value: action.payload.lineNumber,
          tenant: state.theme,
          validationType: 'MSISDN',
        }),
      ).pipe(
        switchMap((clientExists) =>
          from(lineService.fetchOperatorDonor(action.payload.lineNumber)).pipe(
            map((result) =>
              clientExists
                ? fetchOperatorError({
                    errorMessage: 'exists',
                    errorCode: '406',
                    lineId: action.payload.id,
                  })
                : fetchOperatorSuccess({ ...result, lineId: action.payload.id }),
            ),
            catchError((error: Error) =>
              of(
                fetchOperatorError({
                  errorMessage: error.message,
                  errorCode: '500',
                  lineId: action.payload.id,
                }),
              ),
            ),
          ),
        ),
      ),
    ),
  )

const lineEpics = {
  fetchNewNumberEpic,
  fetchOperatorEpic,
}

export default lineEpics
